import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import { useClientFetch } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/types/ClientStatus';
import { fetchOrganizacie } from '../client/external/ciselniky/organizaciaClient';
import Organizacia from '../model/ciselniky/Organizacia';
import Uuid from '../model/types/Uuid';

interface ReturnType {
  organizacie: Organizacia[];
  organizacieStatus: ClientStatus;
}

export default (
  typ: OrganizacnaSkupinaEnum,
  ldap: boolean = undefined,
  legislativna: boolean = undefined,
  ids: Uuid[] = [],
  shouldFetch = true,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    fetchOrganizacie,
    [typ, ids, ldap, undefined, legislativna, undefined, shouldFetch],
    [shouldFetch],
  );
  return <ReturnType> {
    organizacie: data,
    organizacieStatus: status,
  };
};
